import fetchWrapper from './fetch-wrapper';
import { service, handleErrors, normalizeResponse } from './apiServices';
import { EMPLOYEE_SETTINGS_FEATURE_FLAG, EMPLOYEE_NUMBER_SETTINGS_FEATURE_FLAG, ONBOARDING_PREVENT_DUPLICATE_FEATURE_FLAG } from 'constants';
import config from 'config';

const {
	HOST: { APIM_BASE_DOMAIN_URL },
	isLocal
} = config;

const COMPANY_CONFIG_API_URL = `${APIM_BASE_DOMAIN_URL}/hrcompanyconfig/`;
const HR_PRIVATE_SERVICE_URL = `${APIM_BASE_DOMAIN_URL}/hrpprivate/`;
const ONBOARDING_SERVICE_URL = `${APIM_BASE_DOMAIN_URL}/onboardingservice/`;

export function loadUserInfo() {
	let action = `v1/user/me`;

	return fetchWrapper(service(COMPANY_CONFIG_API_URL, action)).then((res) => res.json());
}

//------------------------- Feature Flags ------------------------------------

export function getFeatureFlag(featureName, companyId) {
	let action = `v1/FeatureManager/${featureName}?companyId=${companyId}`;
	return fetchWrapper(service(HR_PRIVATE_SERVICE_URL, action))
		.then(handleErrors)
		.then((res) => res.json());
}

export function getHasOnboardingPreventDuplicateFeatureFlag(companyId) {
	return getFeatureFlag(ONBOARDING_PREVENT_DUPLICATE_FEATURE_FLAG, companyId);
}

export function getHasNewEmployeeSettingsPageEnabled(companyId) {
	if (!isLocal) {
		return getFeatureFlag(EMPLOYEE_SETTINGS_FEATURE_FLAG, companyId);
	}
	return isLocal;
}

export function getHasEmployeeNumberSettingsEnabled(companyId) {
	return getFeatureFlag(EMPLOYEE_NUMBER_SETTINGS_FEATURE_FLAG, companyId);
}

//----------------------------------------------------------------------------

export function getHasProcessflow(companyId) {
	if (!isLocal) {
		let action = `api/v1/HrSettings/company/${companyId}/hasProcessflow`;
		return fetchWrapper(service(COMPANY_CONFIG_API_URL, action))
			.then(handleErrors)
			.then((res) => res.json());
	} else {
		return isLocal;
	}
}

export function loadEmployeeSettings(companyId) {
	let action = `v1/HrSettings/${companyId}`;

	return fetchWrapper(service(COMPANY_CONFIG_API_URL, action))
		.then(handleErrors)
		.then(normalizeResponse);
}

export function loadEmployeeNumberSettings(companyId) {
	let action = `v2/companies/${companyId}/employeeNumber`;

	return fetchWrapper(service(COMPANY_CONFIG_API_URL, action))
		.then(handleErrors)
		.then(normalizeResponse);
}

export function loadCompanyDetails(companyId, clientId) {
	let action = `v1/HrSettings/${companyId}/${clientId}`;

	return fetchWrapper(service(COMPANY_CONFIG_API_URL, action))
		.then(handleErrors)
		.then(normalizeResponse);
}

export function loadHasPendingHiresWithEmployeeNumber(companyId) {
	let action = `v3/newhires/HasPendingHiresWithEmployeeNumber/${companyId}?includeDeletedNewHires=false`;

	return fetchWrapper(service(ONBOARDING_SERVICE_URL, action))
		.then(handleErrors)
		.then((data) => data.json());
}

export function loadHasBSwiftService(companyId, clientId) {
	let action = `api/v1/HrSettings/hasBswiftService/${companyId}/${clientId}`;

	return fetchWrapper(service(COMPANY_CONFIG_API_URL, action))
		.then(handleErrors)
		.then((data) => data.json());
}

export function saveEmployeeSettings(payload) {
	let action = `v1/HrSettings/${payload.companyId}`;
	return fetchWrapper(service(COMPANY_CONFIG_API_URL, action), {
		headers: new Headers({ 'Content-Type': 'application/json' }),
		method: 'PUT',
		body: JSON.stringify(payload)
	})
		.then(handleErrors)
		.then(normalizeResponse);
}

export function saveEmployeeNumberSettings(payload) {
	let action = `v2/companies/${payload.companyId}/employeeNumber`;

	return fetchWrapper(service(COMPANY_CONFIG_API_URL, action), {
		headers: new Headers({ 'Content-Type': 'application/json' }),
		method: 'PUT',
		body: JSON.stringify(payload)
	})
		.then(handleErrors)
		.then(normalizeResponse);
}
